import { render } from "./AddLottoResults.vue?vue&type=template&id=678f7b1a"
import script from "./AddLottoResults.vue?vue&type=script&lang=js"
export * from "./AddLottoResults.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__